import React, { useState } from 'react'
import {
  createFinancierBankAccountAction,
  createVerifiedBankAccountAction,
  updateFinancierBankAccountAction,
} from '../../routes/financier/FinancierDuck'
import { camelToWords } from '../../utils/misc'
import { AddUpiAttributes } from '../addUpiAttributes/AddUpiAttributes'
import Button from '../button'
import CardAttributes from '../cardAttributes'
import ChangeBankAccount from '../changeBankAccount'
import NomineeDetails from '../nomineeDetails'
import Text from '../text'
import { VerifiedDepositAccounts } from '../verifiedDepositAccounts/VerifiedDepositAccounts'
import * as styles from './ProfileDetails.css'

export const ProfileDetails = ({ financier }) => {
  const profileTitles = ['Authorized User', 'Escrow Account', 'Bank Account', 'Verified Accounts', 'Nominees']
  const [activeProfile, setActiveProfile] = useState(0)
  const [showEditBank, setShowEditBank] = useState(false)
  const [showAddBank, setShowAddBank] = useState(false)
  const [selectedDepositAcnt, setSelectedDepositAcnt] = useState('bank')
  const [addNominee, setAddNominee] = useState(false)

  const viewProfileDetails = {
    viewAuthorizedUser: ['fullName', 'PAN', 'aadhaarNumber', 'emailId', 'phoneNumber'],
    viewEscrow: ['accountNumber', 'holderName', 'bankName', 'IFSC', 'branch', 'branchAddress'],
    viewfinancierBank: ['accountNumber', 'holderName', 'bankName', 'IFSC'],
  }

  const handleEditBank = () => {
    setShowEditBank(val => !val)
  }

  const handleAddBank = () => {
    setShowAddBank(val => !val)
  }

  const handleNominee = () => {
    setAddNominee(val => !val)
  }

  return (
    <div className={styles.profileContainer}>
      <div className={styles.profileTitles}>
        {profileTitles.map((title, index) => {
          return (
            <div key={title}>
              <div className={styles.profileDivider} />
              <Button
                handleClick={() => setActiveProfile(index)}
                type='text'
                className={activeProfile === index ? styles.profileTitleBtnFocused : styles.profileTitleBtn}>
                <Text
                  size='0.9'
                  color={activeProfile === index && 'var(--profile-active-text-color)'}
                  className={styles.profileTitle}>
                  {title}
                </Text>
              </Button>
            </div>
          )
        })}
        <div className={styles.profileDivider} />
      </div>

      <div className={styles.profileDetails}>
        {activeProfile === 0 && (
          <div className={styles.profileCard}>
            <Text size='1.2' color='var(--default-profile-text-color)' bold>
              Authorized User
            </Text>
            {Object.entries(financier?.authorizedUser)
              ?.filter(items => viewProfileDetails.viewAuthorizedUser.includes(items[0]))
              ?.map(entry => {
                return (
                  <CardAttributes
                    key={entry[0]}
                    name={camelToWords(entry[0])}
                    value={entry[1]}
                    userId={financier?.authorizedUser?.id}
                  />
                )
              })}
          </div>
        )}

        {activeProfile === 1 && (
          <div className={styles.profileCard}>
            <Text size='1.2' color='var(--default-profile-text-color)' bold>
              Escrow Account (IncomeBazaar Wallet)
            </Text>
            {Object.entries(financier?.escrow)
              ?.filter(items => viewProfileDetails.viewEscrow.includes(items[0]))
              ?.map(entry => {
                return <CardAttributes key={entry[0]} name={camelToWords(entry[0])} value={entry[1]}></CardAttributes>
              })}
          </div>
        )}

        {activeProfile === 2 && (
          <div className={styles.profileCard}>
            <div className={styles.header}>
              <div className={styles.headerTitle}>
                <Text size='1.2' color='var(--default-profile-text-color)' bold>
                  Bank Account
                </Text>
                <Text size='0.8' color='var(--grey-text-subtitle-color)'>
                  Withdrawals from wallet are credited into this account
                </Text>
              </div>
              <Button handleClick={handleEditBank} type='text'>
                {showEditBank ? 'Cancel' : financier?.financierBank?.id ? 'Edit Account' : 'Add Account'}
              </Button>
            </div>
            {showEditBank ? (
              financier?.financierBank?.id ? (
                <ChangeBankAccount
                  handleOnSubmit={updateFinancierBankAccountAction}
                  handleClose={handleEditBank}
                  title={'Edit bank Account'}
                />
              ) : (
                <ChangeBankAccount
                  handleOnSubmit={createFinancierBankAccountAction}
                  handleClose={handleEditBank}
                  title={'Add bank Account'}
                />
              )
            ) : financier?.financierBank?.id ? (
              Object.entries(financier?.financierBank)
                ?.filter(items => viewProfileDetails.viewfinancierBank.includes(items[0]))
                ?.map(entry => {
                  return <CardAttributes key={entry[0]} name={camelToWords(entry[0])} value={entry[1]}></CardAttributes>
                })
            ) : (
              <div>
                <Text>Add your bank account to process withdrawals from wallet</Text>
              </div>
            )}
          </div>
        )}

        {activeProfile === 3 && (
          <div className={styles.profileCard}>
            <div className={styles.header}>
              <div className={styles.headerTitle}>
                <Text size='1.2' color='var(--default-profile-text-color)' bold>
                  Verified Deposit Accounts
                </Text>
                <Text size='0.8' color='var(--grey-text-subtitle-color)'>
                  Credits to IncomeBazaar will reflect only if done from these verified accounts
                </Text>
              </div>
              <Button handleClick={handleAddBank} type='text'>
                {showAddBank ? 'Cancel' : 'Add Account'}
              </Button>
            </div>

            {showAddBank ? (
              <>
                <div className={styles.selectDepositAcntContainer}>
                  <Button
                    label='Bank Account'
                    className={selectedDepositAcnt === 'bank' && styles.selectedDepositAcnt}
                    type='skeleton'
                    handleClick={() => {
                      setSelectedDepositAcnt('bank')
                    }}
                  />
                  <Button
                    label='UPI'
                    className={selectedDepositAcnt === 'upi' && styles.selectedDepositAcnt}
                    type='skeleton'
                    handleClick={() => {
                      setSelectedDepositAcnt('upi')
                    }}
                  />
                </div>
                {selectedDepositAcnt === 'bank' ? (
                  <ChangeBankAccount
                    handleOnSubmit={createVerifiedBankAccountAction}
                    handleClose={handleAddBank}
                    title={'Add verified account'}
                  />
                ) : (
                  <AddUpiAttributes handleClose={handleAddBank} />
                )}
              </>
            ) : (
              <VerifiedDepositAccounts />
            )}
          </div>
        )}

        {activeProfile === 4 && (
          <div className={styles.profileCard}>
            <div className={styles.header}>
              <div className={styles.headerTitle}>
                <Text size='1.2' color='var(--default-profile-text-color)' bold>
                  Nominee Details
                </Text>
                <Text size='0.8' color='var(--grey-text-subtitle-color)'>
                  Nominees for your IncomeBazaar account are as follows
                </Text>
              </div>
              <Button handleClick={handleNominee} type='text'>
                {addNominee ? 'Cancel' : 'Add Nominee'}
              </Button>
            </div>
            <NomineeDetails addNominee={addNominee} setAddNominee={setAddNominee} />
          </div>
        )}
      </div>
    </div>
  )
}
